import {ChangeEvent, KeyboardEvent, useState} from "react";

import {SliderFieldInputProps} from "@/components/form/fields/SliderField/SliderField.types.ts";
import {Input} from "@/components/input/Input.tsx";

import styles from "./SliderField.module.scss";

export const SliderFieldInput = ({id, value, min, max, step, invalid, onChange, onCommit}: SliderFieldInputProps) => {
  const [draft, setDraft] = useState<string>();

  const handleChange = ({target}: ChangeEvent<HTMLInputElement>) => {
    setDraft(target.value);
    if (!Number.isNaN(target.valueAsNumber)) {
      onChange(target.valueAsNumber);
    }
  };
  const commit = () => {
    setDraft(undefined);
    onCommit();
  };
  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key !== "Enter") {
      return;
    }
    const isEmpty = Number.isNaN(event.currentTarget.valueAsNumber);
    commit();
    if (invalid || isEmpty) {
      event.preventDefault();
    }
  };

  return (
    <Input
      id={id}
      type="number"
      size="xsmall"
      className={styles.input}
      value={draft ?? value}
      min={min}
      max={max}
      step={step}
      aria-invalid={invalid}
      onChange={handleChange}
      onBlur={commit}
      onKeyDown={handleKeyDown}
    />
  );
};
